import request from 'utils/request'

export function fetchCountries() {
  return request({
    url: '/countries',
    method: 'get',
  })
}
